// extracted by mini-css-extract-plugin
module.exports = {"primary":"primary_button-module__primary--SJdkJ"};